// components/PromoBanner.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSiteImages } from "../actions/siteImageActions";
import SiteImage from "./SiteImage";

// Below this viewport width we prefer the dedicated mobile banner if the
// admin has uploaded one. Matches the breakpoint other components on the
// home page already use (Hero / vision grid).
const MOBILE_BREAKPOINT = 768;

const PromoBanner = () => {
  const dispatch = useDispatch();
  const { imagesMap } = useSelector((s) => s.siteImages);

  // Track viewport size reactively so a resize / device rotation swaps
  // banners without needing a reload.
  const getIsMobile = () =>
    typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;
  const [isMobile, setIsMobile] = useState(getIsMobile);
  useEffect(() => {
    const onResize = () => setIsMobile(getIsMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Fetch BOTH keys so the conditional below has the data it needs to
  // decide which banner to render.
  useEffect(() => {
    dispatch(fetchSiteImages(["banner_descuentos", "banner_descuentos_mobile"]));
  }, [dispatch]);

  const desktopImg = imagesMap?.["banner_descuentos"];
  const mobileImg = imagesMap?.["banner_descuentos_mobile"];
  const mobileImgExists = !!(mobileImg?.secureUrl || mobileImg?.url);

  // Decide which version to render:
  //   - mobile + admin uploaded a mobile banner → use mobile (square frame)
  //   - mobile + no mobile banner uploaded     → fall back to the desktop
  //                                              banner so the section
  //                                              keeps working as today
  //   - desktop                                → always horizontal banner
  const useMobileBanner = isMobile && mobileImgExists;
  const activeKey = useMobileBanner
    ? "banner_descuentos_mobile"
    : "banner_descuentos";
  const activeImg = useMobileBanner ? mobileImg : desktopImg;

  if (!activeImg?.secureUrl && !activeImg?.url) return null;

  return (
    <div className="container my-4">
      <div
        className="position-relative w-100 overflow-hidden hadacy-promo-banner"
        style={{
          // Square (1:1) on mobile when a mobile-specific banner exists,
          // wide cinematic 4:1 everywhere else.
          aspectRatio: useMobileBanner ? "1 / 1" : "4 / 1",
          background: "#f6f6f6",
          borderRadius: "18px",
          boxShadow: "0 14px 32px rgba(26, 20, 16, 0.08)",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
        }}
      >
        <SiteImage
          // `key` forces a remount when we switch versions so the loader
          // state resets cleanly instead of trying to morph one src into
          // the other (which can briefly show the wrong image).
          key={activeKey}
          keyName={activeKey}
          alt="Promociones Hadacy"
          className="w-100 h-100"
          style={{ objectFit: "cover" }}
        />
      </div>
      <style>{`
        .hadacy-promo-banner:hover {
          transform: translateY(-2px);
          box-shadow: 0 22px 44px rgba(26, 20, 16, 0.12);
        }
      `}</style>
    </div>
  );
};

export default PromoBanner;
